import { SparklesIcon } from "@heroicons/react/20/solid";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { useUser } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";

import useFetch from "../../shared/hooks/useFetch";

const GenerateReport = () => {
	const { user } = useUser();
	const fetchReport = useFetch();
	const navigate = useNavigate();

	const [isGenerating, setIsGenerating] = useState(false);

	const handleGenerate = async () => {
		try {
			toast("Rapport aan het genereren... Dit kan tot een minuut duren", {
				position: "bottom-center",
				theme: "light",
				hideProgressBar: false,
				duration: 60000,
				icon: null,
			});

			setIsGenerating(true);

			await fetchReport(
				`/api/tevredenheid/report/${user.id}/regenerate`,
				{ method: "POST" }
			);

			setIsGenerating(false);

			toast.success("Je rapport staat klaar!", {
				position: "bottom-center",
				theme: "light",
				hideProgressBar: true,
				duration: 800,
				icon: (
					<CheckCircleIcon
						className="text-green-500"
						aria-hidden="true"
					/>
				),
			});

			navigate(0);
		} catch (error) {
			setIsGenerating(false);
			console.error("Error generating report:", error);
		}
	};

	return (
		<button
			onClick={handleGenerate}
			disabled={isGenerating}
			className="cursor-pointer flex items-center gap-2 px-5 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
		>
			<SparklesIcon className="h-5 w-5" />
			{isGenerating ? "Rapport genereren..." : "Genereer AI-verbeterplan"}
		</button>
	);
};

export default GenerateReport;
